import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
// ajuste os caminhos conforme o seu projeto
import { PlanoAcaoService } from 'src/app/services/plano-acao.service';
import { IGrupoHistoricoAcao, IHistoricoAcaoModel, ILinhaHistoricoAcaoModel } from 'src/app/models/placao-acao-log.model';


@Component({
  selector: 'app-plano-acao-form-log-alteracoes',
  templateUrl: './plano-acao-form-log-alteracoes.component.html',
  styleUrls: ['./plano-acao-form-log-alteracoes.component.scss']
})
export class PlanoAcaoFormLogAlteracoesComponent implements OnInit {

  public acaoId = 0;
  public identificador = '';
  public tituloAcao = '';

  public modo: 'tabela' | 'timeline' = 'tabela'; 
  public campoFiltro: string = null;
  public responsavelFiltro: string = null;

  public historico: IHistoricoAcaoModel = {
    linhas: [], campos: [], responsaveis: [], criadoEm: null, criadoPorNome: ''
  };
  public grupos: IGrupoHistoricoAcao[] = [];

  // listas dos filtros: ficam fixas após a primeira carga (o backend as devolve sem filtrar)
  public campos: string[] = [];
  public responsaveis: { value: string; text: string }[] = [];
  private filtrosCarregados = false;

  constructor(
    private dialogRef: MatDialogRef<PlanoAcaoFormLogAlteracoesComponent>,
    private planoAcaoService: PlanoAcaoService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.acaoId = data?.id;
    this.identificador = data?.identificador;
    this.tituloAcao = data?.titulo;
  }

  ngOnInit(): void {
    this.carregar();
  }

  // chamado automaticamente a cada mudança de filtro (sem botão Pesquisar)
  public carregar(): void {
    this.planoAcaoService
      .obterLogAlteracoes(this.acaoId, this.campoFiltro, this.responsavelFiltro)
      .then((res) => {
        if (!res.sucesso) { this.aviso(res.mensagem?.descricao); return; }

        this.historico = res.dados;

        if (!this.filtrosCarregados) {
          this.campos = res.dados.campos || [];
          this.responsaveis = res.dados.responsaveis || [];
          this.filtrosCarregados = true;
        }

        this.agrupar();
      })
      .catch((err) => this.aviso(err?.mensagem?.descricao || 'Erro ao carregar histórico'));
  }

  public alterarModo(modo: 'tabela' | 'timeline'): void {
    this.modo = modo;
  }

  // agrupa por salvamento (mesma data/hora e responsável) para a linha do tempo
  private agrupar(): void {
    const mapa = new Map<string, IGrupoHistoricoAcao>();

    (this.historico.linhas || []).forEach((l: ILinhaHistoricoAcaoModel) => {
      let g = mapa.get(l.grupoId);
      if (!g) {
        g = { grupoId: l.grupoId, dataHora: l.dataHora, responsavelNome: l.responsavelNome, linhas: [] };
        mapa.set(l.grupoId, g);
      }
      g.linhas.push(l);
    });

    this.grupos = Array.from(mapa.values())
      .sort((a, b) => new Date(b.dataHora).getTime() - new Date(a.dataHora).getTime());
  }

  public classeOperacao(codigo: number): string {
    switch (codigo) {
      case 2: return 'badge-success';  // Inclusão
      case 4: return 'badge-danger';   // Exclusão
      default: return 'badge-info';    // Alteração
    }
  }

  public rotuloAlteracoes(qtd: number): string {
    return qtd === 1 ? 'alterou 1 campo' : `alterou ${qtd} campos`;
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  private aviso(text: string): void {
    Swal.fire({
      toast: true, position: 'top-end', icon: 'warning', text,
      showConfirmButton: false, timer: 5000, timerProgressBar: true,
    });
  }
}